
import React, { useState, useEffect } from 'react';
import { PricingHeader } from './components/PricingHeader';
import { PricingGrid } from './components/PricingGrid';
import { useSubscription } from './hooks/useSubscription';
import { ErrorAlertsSection } from './components/ErrorAlertsSection';
import { SubscriptionAlert } from './components/SubscriptionAlert';
import { PricingPlansProvider } from './components/PricingPlansProvider';
import { useAuth } from '@/contexts/AuthContext';

export const PricingPage = () => {
  const { user } = useAuth();
  const [showDetailedError, setShowDetailedError] = useState(false);
  const [errorDetails, setErrorDetails] = useState<string>('');
  
  const { 
    isLoading, 
    error, 
    handleSubscribe, 
    paypalError, 
    hasCredentialError,
    isSubscribed,
    currentSubscription,
    refreshSubscription,
    cleanup
  } = useSubscription();

  // Refresh the subscription status when the page loads
  useEffect(() => {
    if (user) {
      refreshSubscription(false);
    }
    
    // Clean up when component unmounts
    return () => {
      cleanup();
    };
  }, [user, refreshSubscription, cleanup]);

  const onShowDetailedError = () => {
    setShowDetailedError(true);
  };

  return (
    <div className="container py-10">
      <PricingHeader />
      
      {/* Only show critical subscription alerts on pricing page */}
      <SubscriptionAlert 
        isSubscribed={isSubscribed} 
        currentSubscription={currentSubscription}
      />
      
      <ErrorAlertsSection 
        paypalError={paypalError}
        hasCredentialError={hasCredentialError}
        showDetailedError={showDetailedError}
        errorDetails={errorDetails}
        onShowDetailedError={onShowDetailedError}
        setErrorDetails={setErrorDetails}
      />
      
      <PricingPlansProvider user={user} isSubscribed={isSubscribed}>
        {(plans) => (
          <PricingGrid 
            plans={plans} 
            onSubscribe={handleSubscribe} 
            isLoading={isLoading} 
            isLoggedIn={!!user}
            isSubscribed={isSubscribed}
          />
        )}
      </PricingPlansProvider>
    </div>
  );
}
